import { memo } from 'react'
import CurieAvatar from '~/assets/curie-avatar.png'
import { CurieMarkdown } from '~/components/markdown'
import { isTaskCommand, UsedCommandType } from '~/constants/commands'
import { useConversationMetadata, useUser } from '~/hooks'
import { cm, generateAvatar } from '~/utils/utils'
import { CampaignBlock } from './campaignBlocks/CampaignBlock'

export interface CampaignMessageProps {
  message: Message
  inlineChat?: boolean
}

function CampaignChatMessage({ message, inlineChat }: CampaignMessageProps) {
  const className = 'px-6 py-2 text-black max-w-[90%] overflow-y-auto rounded-lg min-w-full'
  const isUser = message.role === 'user'
  const { command } = useConversationMetadata()

  const renderMessage = (message: Message) => {
    if (message.blocks) {
      const messageType = message.blocks[0].type
      let text = ''

      if (messageType === 'pr') text += 'Done! Please check the PR: '
      if (messageType === 'image') text += 'Done! Please check the image below:\n'

      return message.blocks.map((block, index) => (
        <CampaignBlock
          key={block.id || index}
          index={index}
          block={block}
          totalBlock={message.blocks?.length}
        />
      ))
    }

    return <CurieMarkdown text={message.text || ''} />
  }

  if (!inlineChat && isTaskCommand(command as UsedCommandType)) {
    if (message.role == 'user') {
      return null
    }
    return renderMessage(message)
  }

  const messageUserName = message.message_metadata?.user_name || 'User'

  return (
    <div data-testid='message' className={cm('max-w-[100%]', className)}>
      <div className='user flex items-center mt-1'>
        <img
          src={isUser ? generateAvatar(messageUserName) : CurieAvatar}
          alt={message.role}
          className='w-8 h-8 rounded-full select-none'
        />
        <div className='ml-2 font-semibold dark:text-white'>
          {isUser ? messageUserName : 'Curie'}
        </div>
      </div>
      {renderMessage(message)}
    </div>
  )
}

export default memo(
  CampaignChatMessage,
  (prev, next) => JSON.stringify(prev.message) === JSON.stringify(next.message)
)
